import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import { AxiosResponse } from 'axios';
import Client from './client';

export interface API<S> {
  url?: string;
  getItems(config, variableUrl): Promise<AxiosResponse<S[]>>;
  getCurrent(id: number, config: any): Promise<AxiosResponse<S>>;
  createItem(item: S, variableUrl?: string);
  updateItem(item: S, variableUrl?: string);
  deleteItem(id: number, variableUrl?: string);
}

export default class BaseAPI implements API<any> {
  url?: string;

  constructor({ url }: { url?: string }) {
    this.url = url;
  }

  getItems = (config, variableUrl) => {
    const URL = this.url || variableUrl;
    return Client.get(URL, config).catch(errorHandler);
  };

  getCurrent = (id, config) => {
    const URL = `${this.url}/${id}`;
    return Client.get(URL, config).catch(errorHandler);
  };

  createItem = (newItem, variableUrl) => {
    const useUrl = variableUrl || this.url;
    return Client.post(useUrl, newItem).catch(errorHandler);
  };

  updateItem = (item, variableUrl) => {
    const useUrl = variableUrl || this.url;
    return Client.put(`${useUrl}/${item.id}`, item).catch(errorHandler);
  };

  deleteItem = (id, variableUrl) => {
    const useUrl = variableUrl || this.url;
    return Client.delete(`${useUrl}/${id}`).catch(errorHandler);
  };
}
